module.exports = __webpack_public_path__ + "assets/img/border.544f0a48.svg";